
import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, CanLoad, Route, UrlSegment, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService, StorageService } from '../../../shared/service';
import { UserControlService } from "../../../../app/shared/service/userControl/user-control.service";
import { CommonService } from "../../../../app/shared/service/common/common.service";
import { Priveleges } from '../../../shared/lib/model/priveleges';
import { AppRoutes } from '../../../shared/lib/api-constant';

@Injectable({
  providedIn: 'root'
})
export class AccessGuard implements CanActivate, CanActivateChild, CanLoad {
  permissions: any;
  returnTo:any;
  private features: any = {
    home: { access: false, privileges: [] },
    listview: { access: false, privileges: [] },
    contractAgreement: { access: false, privileges: [] },
    contractAgreementApproval: { access: false, privileges: [] },
    contractAgreementCreation: { access: false, privileges: [] },
    alertSubscription: { access: false, privileges: [] },
    MasterDataManagement: { access: false, privileges: [] },
    rolesubscription: { access: false, privileges: [] },
    usermanagement: { access: false, privileges: [] },
    portmaster: { access: false, privileges: [] },
    companymaster: { access: false, privileges: [] },
    currencymanagement: { access: false, privileges: [] },
    profile: { access: false, privileges: [] },
    risconfiguration: { access: false, privileges: [] },
    releasenote: { access: false, privileges: [] },
  };
  priveleges: typeof Priveleges;

  constructor(
    private userControlService: UserControlService, 
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private storageService: StorageService,
  ) {
    this.priveleges = Priveleges;
    this.userControlService.$userFeatures.subscribe((featureList: any) => {
      if (featureList.data) {
        this.permissions = featureList.data;
        //console.log(featureList)
        featureList.data.features.forEach((permission: any) => {
          // Dynamically assign features and privileges
          switch (permission.featureName) {
            case 'home':
              this.features.home.access = true;
              this.features.home.privileges = permission.privileges;
              break;
            case 'list-view':
              this.features.listview.access = true;
              this.features.listview.privileges = permission.privileges;
              break;
              case 'risk-configuration':
              this.features.risconfiguration.access = true;
              this.features.risconfiguration.privileges = permission.privileges;
              break;
              case 'data-upload-download':
              this.features.releasenote.access = true;
              this.features.releasenote.privileges = permission.privileges;
              break;
            case 'contract-agreement':
              this.features.contractAgreement.access = true;
              this.features.contractAgreement.privileges = permission.privileges;
              break;
            case 'contract-agreement-approval':
              this.features.contractAgreementApproval.access = true;
              this.features.contractAgreementApproval.privileges = permission.privileges;
              break;
            case 'contract-agreement-creation':
              this.features.contractAgreementCreation.access = true;
              this.features.contractAgreementCreation.privileges = permission.privileges;
              break;
            case 'profile':
              this.features.profile.access = true;
              this.features.profile.privileges = permission.privileges;
              break;
            case 'alert-subscription':
              this.features.alertSubscription.access = true,
                this.features.profile.alertSubscription = permission.privileges;
              break;
            case 'Master Data Management':
              this.features.MasterDataManagement.access = true;
              this.features.MasterDataManagement.privileges = permission.privileges;
              break;
            case 'Role Management':
              this.features.rolesubscription.access = true;
              this.features.rolesubscription.privileges = permission.privileges;
              break;
            case 'User Management':
              this.features.usermanagement.access = true;
              this.features.usermanagement.privileges = permission.privileges;
              break;
            case 'Port Master':
              this.features.portmaster.access = true;
              this.features.portmaster.privileges = permission.privileges;
              break;
            case 'Company Master':
              this.features.companymaster.access = true;
              this.features.companymaster.privileges = permission.privileges;
              break;
            case 'Currency Management':
              this.features.currencymanagement.access = true;
              this.features.currencymanagement.privileges = permission.privileges;
              break;
          }
        });
      }
    });
  }

  private hasAccessToFeature(feature: string, privilege: string): boolean {
    const featurePermission = this.permissions?.features.find((perm:any) => perm.featureKey === feature);
    return featurePermission?.privileges.some((priv: any) => priv.privilegeKey === privilege) 
  }

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean > {
  //     let params: any | null = route.params['token'] || route.queryParams['token'];
  //   if (params) {
  //     params = JSON.parse(atob(params));
  //     if ( params?.email) {
  //     this.returnTo = params?.returnTo;
	//   this.storageService.setItem("returnTo", params?.returnTo);
  //   }
  // }
    const url = state.url;
    this.userControlService.$userFeatures.subscribe((featureList: any) => {
      if (featureList) {
        this.permissions = featureList;
      }})
      if(url.includes('/common/assign')){
       const userPermission=await this.userControlService.getUserFeaturesWithPrivileges().toPromise();
          if (userPermission) {
            this.permissions = userPermission.data;
          }
      }
      if(this.permissions?.features){

    if (url.includes('contract-agreement-creation') && !this.hasAccessToFeature('CONTRACT_AGREEMENT_CREATION', Priveleges.READ)) {
      // this.authService.loginRedirect('');
       return false;
     }

    if (url.includes('contract-agreement-approval') && !this.hasAccessToFeature('CONTRACT_AGREEMENT_APPROVAL', Priveleges.READ)) {
      //this.authService.loginRedirect('');
      return false;
    }

    if (url.includes('profile') && !this.hasAccessToFeature('profile', Priveleges.READ)) {
      //this.authService.loginRedirect('');
      return false;
    }
    if(url.includes('alert-subscription') && !this.hasAccessToFeature('ALERT_SUBSCRIPTION', Priveleges.READ)){
   return false;
    }
    if (url.includes('list-view') && !this.hasAccessToFeature('LIST_VIEW', Priveleges.READ)) {
      //this.authService.loginRedirect('');
      return false;
    }
    if (url.includes('role-management') && !this.hasAccessToFeature('DND_ROLE_MANAGEMENT', Priveleges.READ)) {
      //this.authService.loginRedirect('');
      return false;
    }
    if (url.includes('user-control') && !this.hasAccessToFeature('USER_MANAGEMENT', Priveleges.READ)) {
      //this.authService.loginRedirect('');
      return false;
    }
    if (url.includes('common') && !this.hasAccessToFeature('USER_MANAGEMENT', Priveleges.READ)) {
      this.router.navigate([AppRoutes.AuthAbstract.ACCESS]);
      return false;
    }
    if (url.includes('company-management') && !this.hasAccessToFeature('COMPANY_MANAGEMENT', Priveleges.READ)) {
      //this.authService.loginRedirect('');
      return false;
    }
  }
    return true;
 
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.canActivate(childRoute, state);
  }

  canLoad(
    route: Route,
    segments: UrlSegment[]): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    console.log('canLoad');
    return true;
  }
}

